import { retrieveServices as apiRetrieveServices } from '@/api/api'

export default {

  RETRIEVE_SERVICES: ({ commit }) => {
    return apiRetrieveServices().then(responseData => {
      commit('SET_SERVICES', { services: responseData.response.data })
    }).catch(error => Promise.reject(error.response.data))
  }
}
